export default __webpack_public_path__ + "static/media/logo.eb6059f7.png";